import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import PrimeTable from '../../../components/PrimeTable'
import Edicao from './Edicao'

const ContaBancaria = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const handleRemove = useCallback((dados) => {
    metodoPrograma('exclui', { idContaBancaria: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const voltar = () => {
    setTela('lista')
    setDados([])
  }

  const handleClick = (value) => {
    setDados(value)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlContaBancaria" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <Edicao {...{ dados, voltar, setTela }} />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              {localAtendimento && (
                <PrimeTable
                  codigo="CtrlContaBancaria"
                  action="lista"
                  rows={10}
                  habSearch
                  head={['Empresa', 'Nome', 'Inclusão', 'Exclusão']}
                  line={(item) => [item[1][1], item[2], item[3], item[4]]}
                  collumnsDateHour={[2, 3]}
                  parametros={{ idLocalAtendimento: localAtendimento[0] }}
                  onRowSelect={handleClick}
                  onDelete={{ index: 3, action: handleRemove }}
                  refresh={refresh}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default ContaBancaria
